import React, { PropsWithChildren } from "react";
import { ProfileHeader } from "../components/commonComponents";
import { useAppSelector } from "../services/store";
import { getShowDownloadAppBanner } from "src/shared/redux-state/src";
import { useWindowWidth } from "../utilities/helpers";

type ProfileLayoutProps = {
    title?: string,
    fixedFooter?: boolean,
    showProfileImage?: boolean,
    showDownloadBtn?: boolean,
    handleDownload?: () => void,
    isPrintPage?: boolean;
    handlePrint?: () => void;
}
const ProfileLayout: React.FC<PropsWithChildren<ProfileLayoutProps>> = ({ children, title, fixedFooter = false, showProfileImage = true, showDownloadBtn, handleDownload, isPrintPage, handlePrint }) => {

    const showDownloadAppBanner = useAppSelector(getShowDownloadAppBanner);
    const width = useWindowWidth();

    return (
        <div className={`main-wrapper bg-white container ${showDownloadAppBanner ? (width > 567 ? 'pd-t-86' : 'pd-t-92') : 'pd-t-50'} ${fixedFooter ? 'pd-b-70' : 'pd-b-20'}`}>
            <ProfileHeader 
                title={title} 
                showProfileImage={showProfileImage} 
                showDownloadBtn={showDownloadBtn}
                handleDownload={handleDownload}
                isPrintPage={isPrintPage}
                handlePrint={handlePrint}
            />
            {children}
        </div>
    );
}

export default ProfileLayout;